import { render, staticRenderFns } from "./SampleItemMenu.vue?vue&type=template&id=0a518141&scoped=true&"
import script from "./SampleItemMenu.vue?vue&type=script&lang=js&"
export * from "./SampleItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./SampleItemMenu.vue?vue&type=style&index=0&id=0a518141&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a518141",
  null
  
)

export default component.exports